import { GuestStatus } from "../types";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface connectGuest {
  message: string | undefined;
  primaryGuestId: string;
  primaryGuestName: string;
  primaryGuestStatus: GuestStatus;
  // key is guestId
  plusOnes: { [key: string]: { name: string; status: GuestStatus } };
}

const formSlice = createGenericFormSlice({
  name: "connectGuest",
  initialState: {} as SliceState<connectGuest>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const connectGuestFormReducer = formSlice.reducer;
export default connectGuestFormReducer;
